'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { pageTitleFromPathname } from '@/lib/page-title';

export function PageTitleUpdater() {
  const pathname = usePathname();

  useEffect(() => {
    const title = pageTitleFromPathname(pathname);
    const restoreTitle = () => {
      if (document.title !== title) document.title = title;
    };
    restoreTitle();
    // App Router can apply the shared server metadata after this effect.
    // Keep the route's public label when that delayed update replaces <title>.
    const observer = new MutationObserver(restoreTitle);
    observer.observe(document.head, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [pathname]);

  return null;
}
